import { ConditionalSnow, space18, BWHeader, getStyle } from "../dist/helpers";
import { useState, useEffect } from "react";
import { loginUser } from "../api";
import { Link } from "react-router-dom";
import { useFormState, LoadingSpinner } from "../dist/formUtils";

export default function Login(props) {
  const [snowIsEnabled] = useState(false);
  const { dark, updateLoginState } = props;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);

  const {
    formData: { username, password },
    updateFormData,
    resetForm,
    isLoading,
    setLoading,
    message,
    messageType,
    showMessage,
    isInitializing,
    setInitializing
  } = useFormState({ username: "", password: "" });

  useEffect(() => {
    const savedLoginState = localStorage.getItem('loginState');
    if (savedLoginState) {
      try {
        const parsedState = JSON.parse(savedLoginState);
        setIsLoggedIn(parsedState.isLoggedIn);
        setUserData(parsedState.userData);
        updateLoginState(parsedState.isLoggedIn, parsedState.userData);
      } catch (error) {
        console.error('Error parsing saved login state:', error);
        localStorage.removeItem('loginState');
      }
    }
    setInitializing(false);
  }, [updateLoginState, setInitializing]);

  if (isInitializing) {
    return <LoadingSpinner />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    showMessage("");

    try {
      const response = await loginUser(username, password);
      if (response.success) {
        console.log('Login API response data:', response.data);
        showMessage("Login successful! Welcome back.", "success");
        setIsLoggedIn(true);

        const loggedInUsername = username;
        resetForm();


        let userDataToSave = { ...response.data };


        if (!userDataToSave.username) {
          userDataToSave.username = loggedInUsername;
        }


        if (!userDataToSave.id) {
          userDataToSave.id = userDataToSave.username || loggedInUsername;
        }

        setUserData(userDataToSave);


        localStorage.setItem('loginState', JSON.stringify({
          isLoggedIn: true,
          userData: userDataToSave
        }));

        updateLoginState(true, userDataToSave);
      } else {
        showMessage(response.message || "Login failed. Please check your credentials.", "error");
      }
    } catch (error) {
      console.error('Error during login:', error);
      showMessage("An error occurred. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserData(null);
    showMessage("");

    localStorage.removeItem('loginState');

    updateLoginState(false, null);
  };

  const loginForm = (
    <div className="container py-4" style={{ position: "relative" }}>
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div
            className="h-100 p-4"
            style={getStyle(dark)}
          >
            <h2 className={`text-center mb-4 ${dark ? "text-white" : ""}`}>
              Login
            </h2>

            {message && (
              <div className={`alert alert-${messageType === "success" ? "success" : "danger"} mb-3`}>
                {message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="username" className={`form-label ${dark ? "text-white" : ""}`}>
                  Username
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="username"
                  value={username}
                  onChange={(e) => updateFormData('username', e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="mb-3">
                <label htmlFor="password" className={`form-label ${dark ? "text-white" : ""}`}>
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => updateFormData('password', e.target.value)}
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? "Logging in..." : "Login"}
                </button>
              </div>

              <div className="text-center mt-3">
                <p className={`mb-2 ${dark ? "text-white" : "text-muted"}`}>
                  Don't have an account?
                </p>
                <Link
                  to="/signup"
                  className={`text-decoration-none ${dark ? "text-info" : "text-primary"}`}
                  style={{ fontWeight: '500' }}
                >
                  Create Account
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

  const userProfile = (
    <div className="container py-4" style={{ position: "relative" }}>
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div
            className="h-100 p-4"
            style={getStyle(dark)}
          >
            <h2 className={`text-center mb-4 ${dark ? "text-white" : ""}`}>
              Welcome!
            </h2>

            <div className={`text-center mb-4 ${dark ? "text-white" : ""}`}>
              <h4>Hello, {userData?.username || username}!</h4>
              <p className="text-muted">You are successfully logged in.</p>
            </div>

            <div className="d-grid">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{
      opacity: 1,
      minHeight: '100vh'
    }}>
      <center>
        {ConditionalSnow(snowIsEnabled)}
        {BWHeader(
          dark,
          isLoggedIn ? "Welcome Back" : "Login",
          isLoggedIn ? `Welcome back, ${userData?.username || username}! 🎉` : "Please enter your credentials to access your account. 🔐"
        )}
        <br />

        {isLoggedIn ? userProfile : loginForm}
        <br />

        {space18}
      </center>
    </div>
  );
}
